<template>
  <div class="datacontent solid-table common_radius">
    <div class="firstrow">
      <span class="label">选择通道</span>
      <el-select v-model="selectHeight" @change="doSelectChannel">
        <el-option
          v-for="item in channelList"
          :label="item.heights"
          :key="item.channelId"
          :value="item.channelId"
        ></el-option>
      </el-select>
    </div>
    <div class="charts_tab">
      <span
        @click="changeCharts('weiBull')"
        :class="{ active: activeIndex == 'weiBull' }"
        >威布尔分布</span
      >
      <span
        @click="changeCharts('windPower')"
        :class="{ active: activeIndex == 'windPower' }"
        >风速风能概率分布</span
      >
    </div>
    <div v-if="showWeiBull">
      <echart
        :option="willOption"
        :notMerge="false"
        :divStyle="{ with: '99%', height: '500px' }"
      ></echart>
    </div>
    <div v-if="showPowerScale">
      <echart :option="speedOption" :notMerge="false"></echart>
    </div>
    <div class="tableDiv">
      <el-table
        :data="tableData"
        style="width:100%"
        border
        :header-cell-style="{
          fontSize: '16px',
          fontWeight: 'bold',
          color: '#444455',
          backgroundColor: 'rgb(180, 211, 238)'
        }"
        :row-class-name="tableRowClassName"
      >
        >
        <el-table-column
          prop="speedSpan"
          label="风速(m/s)"
          min-width="10%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="frequencyList"
          label="风速频次"
          min-width="30%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="speedFrequency"
          label="风速频率(％)"
          min-width="30%"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="powerFrequencyList"
          label="风能占比(％)"
          align="center"
          min-width="30%"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
export default {
  data() {
    return {
      selectHeight: '',
      showWeiBull: true,
      showPowerScale: false,
      channelList: [],
      tableData: [],
      activeIndex: 'weiBull',
      willOption: {},
      speedOption: {}
    };
  },
  computed: {
    towerInfo: function() {
      return this.$store.state.WindData.towerObj;
    }
  },
  watch: {
    towerInfo: {
      handler(newVal, oldValue) {
        if (!isEqual(newVal, oldValue)) {
          this.getData(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    handleSelect(index) {
      if (index === 'weiBull') {
        this.showWeiBull = true;
        this.showPowerScale = false;
      } else {
        this.showWeiBull = false;
        this.showPowerScale = true;
      }
    },
    async getData(towerInfo, channelId, search) {
      let { towerId, versionId } = towerInfo || {};
      if (!towerId && !versionId) return;
      let res = await this.$fetch('/winddata/WindAnalyze/getWeiBullData', {
        module: 'windData',
        // showLoading: true,
        params: {
          channelId: channelId ? channelId : 0,
          towerId,
          versionId
        }
      });
      if (res.code == 0) {
        let resdata = res.data;
        let {
          speedList,
          speedRangeList,
          weibullData,
          frequencyList,
          speedFrequencyList,
          powerFrequencyList
        } = resdata || {};
        let a = resdata.weibull_a;
        let k = resdata.weibull_k;
        let subtext = 'A: ' + a + '   K: ' + k;
        if (!search) {
          this.channelList = resdata.channelList;
          if (this.channelList.length > 0) {
            this.selectHeight = this.channelList[0].channelId;
          }
        }
        let ESpeedFrequencyList = [...speedFrequencyList];
        ESpeedFrequencyList.pop();
        let EPowerFrequencyList = [...powerFrequencyList];
        EPowerFrequencyList.pop();
        this.willOption = {
          title: {
            text: '',
            subtext: subtext,
            right: '150',
            subtextStyle: {
              color: '#222233'
            }
          },
          xAxis: {
            name: '风速(m/s)',
            type: 'category',
            nameTextStyle: {
              padding: [8, 8, 8, 8]
            },
            data: speedList,
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#222233' //这里用参数代替了
              }
            }
          },
          yAxis: [
            {
              name: '频率(%)',
              nameLocation: 'end',
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#222233'
                }
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#222233' //这里用参数代替了
                }
              }
            }
          ],
          tooltip: {
            trigger: 'axis'
          },
          backgroundColor: '#fff',
          legend: {
            data: [
              {
                name: '风速频率',
                icon: 'circle'
                // textStyle: {
                //   color: '#63b8ff'
                // }
              },
              {
                name: '威布尔',
                icon: 'circle'
                // textStyle: {
                //   color: '#ffd700'
                // }
              }
            ],
            textStyle: {
              color: '#222233'
            },
            left: 'center'
          },
          series: [
            {
              name: '风速频率',
              type: 'bar',
              color: '#63b8ff',
              yAxisIndex: 0,
              data: ESpeedFrequencyList
            },
            {
              name: '威布尔',
              type: 'line',
              smooth: true,
              color: '#ffd700',
              stack: 'a',
              data: weibullData
            }
          ]
        };
        // let echartObj1 = echart.init(this.$refs.weiBullEChart);
        // echartObj1.setOption(option);
        this.speedOption = {
          title: {
            subtext: ''
          },
          backgroundColor: '#fff',
          xAxis: {
            name: '风速(m/s)',
            type: 'category',
            nameTextStyle: {
              padding: [8, 8, 8, 8]
            },
            data: speedList,
            axisLine: {
              lineStyle: {
                color: '#222233'
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          yAxis: [
            {
              name: '频率(%)',
              nameLocation: 'end',
              type: 'value',
              axisLine: {
                lineStyle: {
                  color: '#222233'
                }
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              }
            }
          ],
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: [
              { name: '风速频率', icon: 'circle' },
              { name: '风能占比', icon: 'circle' }
            ],
            textStyle: {
              color: '#222233'
            },
            left: 'center'
          },
          series: [
            {
              name: '风速频率',
              type: 'bar',
              color: '#63b8ff',
              yAxisIndex: 0,
              data: ESpeedFrequencyList
            },
            {
              name: '风能占比',
              type: 'bar',
              color: '#ffd700',
              yAxisIndex: 0,
              data: EPowerFrequencyList
            }
          ]
        };
        // let echartObj2 = echart.init(this.$refs.powerScaleEChart);
        // echartObj2.setOption(optionPower);

        let dataList = [];
        weibullData.push('');
        for (let i = 0; i < speedRangeList.length; i++) {
          dataList.push({
            speedSpan: speedRangeList[i],
            frequencyList: frequencyList[i],
            weibull: weibullData[i],
            speedFrequency: speedFrequencyList[i],
            powerFrequencyList: powerFrequencyList[i]
          });
        }
        this.tableData = dataList;
      }
    },
    doSelectChannel(val) {
      this.getData(this.towerInfo, val, true);
    },
    changeCharts(tab) {
      if (this.activeIndex === tab) return;
      this.activeIndex = tab;
      if (tab === 'weiBull') {
        this.showWeiBull = true;
        this.showPowerScale = false;
      } else {
        this.showWeiBull = false;
        this.showPowerScale = true;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    }
  },
  mounted() {
    this.getData(this.towerInfo);
  }
};
</script>
<style lang="less" scoped>
.eChartLine {
  width: 99%;
  height: 500px;
}
.datacontent {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: rgb(240, 245, 250);
  .firstrow {
    background: #2f6ba44d;
    padding: 13px 20px 13px 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    .label {
      font-size: 16px;
      font-weight: bold;
      color: #222233;
      margin-right: 10px;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      text-align: right;
      width: 70px;
    }
  }
  .tableDiv {
    width: 100%;
    text-align: center;
  }
}
.charts_tab {
  height: 28px;
  font-size: 0;
  border: 1px solid #0057aaff;
  width: 250px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  overflow: hidden;
  line-height: 26px;
  box-sizing: border-box;
  margin: 20px 0;
  span {
    display: inline-block;
    font-size: 14px;
    color: #0057aaff;
    text-align: center;
    flex: 1;
    height: 100%;
    cursor: pointer;
    &.active {
      color: #fff;
      background: #0057aaff;
      background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
    }
  }
}
</style>
